// Third Party Library
import { useState, useEffect } from "react";
import { Dropdown, message } from "antd";
import { useDispatch, useSelector } from "react-redux";

// Constants Library
import { TEMPLATE } from "../../../../constants";

// Components Library
import { TableList, ButtonLink, DrawerRemark } from "../../../../components";
import { DrawerEditEmployer } from "../DrawerCreateEditEmployer";
import { ActionItems } from "./actions";

// Handler Library
import { tableHDLR, filter } from "../../../../handlers";

// Services Library
import { REDUX as REDUX_UTIL } from "../../../../../v1/services/util";

// Redux Actions

// Styles Library

const { EMPLOYER_SUMMARY_COL } = TEMPLATE.TABLEDATA.EMPLOYER;
const { reduxStoreWrapper } = REDUX_UTIL;
const { EMPLOYER_STATUS_TITLE } = TEMPLATE.EMPLOYER;

const TableEmployer = (props) => {
  const {
    source,
    filteredData,
    paginatedData,
    tabKey,
    setFilteredData,
    selectedRow,
    setSelectedRow,
  } = props;
  const dispatch = useDispatch();

  const [messageApi, contextHolder] = message.useMessage();

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [tabStatus, setTabStatus] = useState({});
  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [isOpenRemark, setIsOpenRemark] = useState(false);
  const [data, setData] = useState({});
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const [originalData, setOriginalData] = useState([]);
  const [isData, setIsData] = useState(false);

  const company = useSelector(reduxStoreWrapper("company.byID"));
  const loading = useSelector(reduxStoreWrapper("style.loading.employer"));
  const user = useSelector(reduxStoreWrapper("user"));

  useEffect(() => {
    if (originalData?.length === 0 && !isData && filteredData[tabKey]?.length) {
      setOriginalData(filteredData[tabKey]);
      setIsData(true);
    }
  }, [filteredData, isData, tabKey]);


  const filterData = (data) =>
    filter.filterHDLR.tableData(
      data,
      filteredInfo,
      sortedInfo,
    );

  useEffect(() => {
    const filteredAndSortedData = filterData(source);

    if (tabStatus[tabKey] && filteredAndSortedData.length !== 0) {
      setFilteredData(filteredAndSortedData);
    }
  }, [tabKey, tabStatus[tabKey], sortedInfo, filteredInfo]);

  const handleTableChange = (_, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
    setTabStatus((prev) => ({
      ...prev,
      [tabKey]: true,
    }));
  };

  const handleSearch = (_, confirm) => {
    confirm();
  };

  const columns = [
    ...EMPLOYER_SUMMARY_COL({
      func: {
        handleSearch,
        DrawerRemark: (data) => {
          setIsOpenRemark(true);
          setData(data);
        },
      },
      redux: {
        company,
      },
    }),
    {
      title: "Actions",
      width: 100,
      fixed: "right",
      render: (_, record) => {
        return (
          <Dropdown
            menu={{
              items: ActionItems(
                record,
                setData,
                setIsOpenEdit,
                setIsOpenRemark,
                dispatch,
                messageApi,
                user
              ),
            }}
          >
            <ButtonLink>Actions</ButtonLink>
          </Dropdown>
        );
      },
    },
  ];

  const onSelectRow = (record, selected) => {
    tableHDLR.selectRow(
      setSelectedRowKeys,
      setSelectedRow,
      selectedRow,
      selectedRowKeys,
      record,
      selected
    );
  };

  const onSelectAllRows = (selected, selectedRows, changeRows) => {
    tableHDLR.selectAllRows(
      setSelectedRowKeys,
      setSelectedRow,
      selectedRow,
      selectedRowKeys,
      changeRows,
      selected
    );
  };

  const rowSelection = {
    selectedRowKeys,
    onSelect: onSelectRow,
    onSelectAll: onSelectAllRows,
  };

  return (
    <>
      {contextHolder}
      <DrawerRemark
        isOpen={isOpenRemark}
        setIsOpen={setIsOpenRemark}
        refid={data?.uid}
        statusData={EMPLOYER_STATUS_TITLE}
        memid={data?.memid}
      />
      <DrawerEditEmployer
        isOpen={isOpenEdit}
        setIsOpen={setIsOpenEdit}
        data={data}
        company={company}
      />
      <TableList.DataList
        paginatedData={paginatedData}
        columnData={columns}
        rowSelection={rowSelection}
        onChange={handleTableChange}
        loading={loading}
      />
    </>
  );
};

export default TableEmployer;
